// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-error-modal_backdrop__RnauM {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.58);
  backdrop-filter: blur(6px);
}

.auth-error-modal_modal__OUEJM {
  position: relative;
  width: min(420px, 100%);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 8px;
  padding: 30px 28px 26px;
  background:
    linear-gradient(145deg, rgba(18, 24, 12, 0.97), rgba(52, 68, 4, 0.96)),
    #1f2a0d;
  box-shadow:
    0 24px 70px rgba(0, 0, 0, 0.54),
    inset 0 0 28px rgba(157, 209, 2, 0.15);
  color: #ffffff;
  text-align: center;
}

.auth-error-modal_closeButton__066m7 {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.auth-error-modal_closeButton__066m7:hover {
  background: rgba(255, 255, 255, 0.18);
}

.auth-error-modal_iconWrap__RDAAA {
  width: 58px;
  height: 58px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: rgba(218, 38, 18, 0.18);
  color: #ffab00;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  box-shadow: 0 0 22px rgba(255, 171, 0, 0.24);
}

.auth-error-modal_copy__U4lVQ h2 {
  margin: 0 0 10px;
  font-family: 'Freckle Face', cursive;
  font-size: 32px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0;
  color: #ffab00;
}

.auth-error-modal_copy__U4lVQ p {
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.88);
}

.auth-error-modal_actionButton__vJMVo {
  margin-top: 22px;
  min-width: 132px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 30px;
  background: linear-gradient(90deg, #da2612 0%, #9dd102 100%);
  color: #ffffff;
  font-family: 'Freckle Face', cursive;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
}

.auth-error-modal_actionButton__vJMVo:hover {
  filter: brightness(1.08);
}

@media (max-width: 768px) {
  .auth-error-modal_modal__OUEJM {
    padding: 28px 22px 24px;
  }

  .auth-error-modal_copy__U4lVQ h2 {
    font-size: 28px;
  }

  .auth-error-modal_copy__U4lVQ p {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/auth/components/auth-error-modal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB;;WAES;EACT;;0CAEwC;EACxC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,4DAA4D;EAC5D,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(0, 0, 0, 0.58);\n  backdrop-filter: blur(6px);\n}\n\n.modal {\n  position: relative;\n  width: min(420px, 100%);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 8px;\n  padding: 30px 28px 26px;\n  background:\n    linear-gradient(145deg, rgba(18, 24, 12, 0.97), rgba(52, 68, 4, 0.96)),\n    #1f2a0d;\n  box-shadow:\n    0 24px 70px rgba(0, 0, 0, 0.54),\n    inset 0 0 28px rgba(157, 209, 2, 0.15);\n  color: #ffffff;\n  text-align: center;\n}\n\n.closeButton {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 34px;\n  height: 34px;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.closeButton:hover {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.iconWrap {\n  width: 58px;\n  height: 58px;\n  margin: 0 auto 16px;\n  border-radius: 50%;\n  background: rgba(218, 38, 18, 0.18);\n  color: #ffab00;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 25px;\n  box-shadow: 0 0 22px rgba(255, 171, 0, 0.24);\n}\n\n.copy h2 {\n  margin: 0 0 10px;\n  font-family: 'Freckle Face', cursive;\n  font-size: 32px;\n  font-weight: 400;\n  line-height: 1;\n  letter-spacing: 0;\n  color: #ffab00;\n}\n\n.copy p {\n  margin: 0;\n  font-family: Inter, sans-serif;\n  font-size: 15px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.88);\n}\n\n.actionButton {\n  margin-top: 22px;\n  min-width: 132px;\n  height: 42px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 30px;\n  background: linear-gradient(90deg, #da2612 0%, #9dd102 100%);\n  color: #ffffff;\n  font-family: 'Freckle Face', cursive;\n  font-size: 20px;\n  cursor: pointer;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);\n}\n\n.actionButton:hover {\n  filter: brightness(1.08);\n}\n\n@media (max-width: 768px) {\n  .modal {\n    padding: 28px 22px 24px;\n  }\n\n  .copy h2 {\n    font-size: 28px;\n  }\n\n  .copy p {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `auth-error-modal_backdrop__RnauM`,
	"modal": `auth-error-modal_modal__OUEJM`,
	"closeButton": `auth-error-modal_closeButton__066m7`,
	"iconWrap": `auth-error-modal_iconWrap__RDAAA`,
	"copy": `auth-error-modal_copy__U4lVQ`,
	"actionButton": `auth-error-modal_actionButton__vJMVo`
};
export default ___CSS_LOADER_EXPORT___;
